import { DataGrid, GridCellParams, GridColDef } from '@mui/x-data-grid';
import { format } from 'date-fns';
import { getDeviceAudit } from 'lib/firebase';
import { useEffect, useState } from 'react';
import { Device, DeviceAudit as DeviceAuditType } from 'types';
import styles from './DeviceAudit.module.scss';
interface DeviceAuditProps {
    device: Device;
}

export const DeviceAudit = ({ device }: DeviceAuditProps) => {
    const [auditList, setAuditList] = useState<DeviceAuditType[]>([]);

    const auditColumns: GridColDef[] = [
        {
            field: 'time',
            headerName: 'Time',
            flex: 1,
            valueFormatter(params) {
                return params.value
                    ? format(params.value, 'MM/dd/yy hh:mm a')
                    : '-';
            },
            sortingOrder: ['asc', 'desc'],
        },
        {
            field: 'email',
            headerName: 'Email',
            flex: 2,
            sortingOrder: ['asc', 'desc'],
        },
        {
            field: 'supplierId',
            headerName: 'Supplier',
            flex: 2,
            sortingOrder: ['asc', 'desc'],
        },
        {
            field: 'old_val',
            headerName: 'Old Value',
            flex: 3,
            renderCell: (params) => <ValueChangeCell {...params} />,
            sortingOrder: ['asc', 'desc'],
        },
        {
            field: 'new_val',
            headerName: 'New Value',
            flex: 3,
            renderCell: (params) => <ValueChangeCell {...params} />,
            sortingOrder: ['asc', 'desc'],
        },
    ];

    useEffect(() => {
        if (device?.deviceId) {
            getDeviceAudit(device.deviceId).then((result) => {
                if (result) {
                    setAuditList(
                        Object.keys(result).map((id) => ({ ...result[id], id }))
                    );
                } else {
                    setAuditList([]);
                }
            });
        }
    }, [device, setAuditList]);

    return (
        <div data-testid="DeviceAudit" className={styles.container}>
            <DataGrid
                rows={auditList}
                columns={auditColumns}
                disableSelectionOnClick
                getRowHeight={() => 'auto'}
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'time', sort: 'desc' }],
                    },
                }}
                disableColumnMenu
            />
        </div>
    );
};

const ValueChangeCell = (cellParams: GridCellParams) => {
    const value = cellParams.value;

    if (value) {
        return (
            <ul>
                {Object.keys(value).map((val) => (
                    <li
                        key={`${cellParams.id}_${val}`}
                        className={!value[val] ? styles.missingItem : ''}
                    >
                        {value[val] ? `${val}: ${value[val]}` : val}
                    </li>
                ))}
            </ul>
        );
    }

    return <div>-</div>;
};
